(function($) {

	var apiKey = 'AIzaSyDtwXZrQQHLV28Ku38RKyzbjtFQcGv6LSc';

	function attachGoogleMapsLib(callback) {
		if (window.google && window.google.map) {
			callback();
			return;
		}


		var el = document.createElement("script");
		$(el).on("load", function() {
			callback();
		});
		el.type = "text/javascript";
		el.src = "https://maps.googleapis.com/maps/api/js?key=" + apiKey;
		window.document.head.appendChild(el);

	}

	var map;

	//https://snazzymaps.com/style/86393/orange-style2

	var mapStyle = [
		{
			"featureType": "administrative",
			"elementType": "labels.text.fill",
			"stylers": [
				{
					"color": "#444444"
				}
			]
		},
		{
			"featureType": "administrative.country",
			"elementType": "geometry",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "landscape",
			"elementType": "all",
			"stylers": [
				{
					"color": "#f2f2f2"
				}
			]
		},
		{
			"featureType": "landscape.man_made",
			"elementType": "geometry",
			"stylers": [
				{
					"color": "#ffddc1"
				}
			]
		},
		{
			"featureType": "landscape.man_made",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"hue": "#ff0000"
				}
			]
		},
		{
			"featureType": "landscape.natural",
			"elementType": "geometry",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "landscape.natural",
			"elementType": "geometry.fill",
			"stylers": [
				{
					"color": "#cae5a7"
				}
			]
		},
		{
			"featureType": "landscape.natural.terrain",
			"elementType": "geometry",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "poi",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road",
			"elementType": "all",
			"stylers": [
				{
					"saturation": -100
				},
				{
					"lightness": 45
				}
			]
		},
		{
			"featureType": "road.highway",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "simplified"
				}
			]
		},
		{
			"featureType": "road.arterial",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "road.local",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "on"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "all",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "geometry.stroke",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "transit",
			"elementType": "labels.icon",
			"stylers": [
				{
					"visibility": "off"
				}
			]
		},
		{
			"featureType": "water",
			"elementType": "all",
			"stylers": [
				{
					"color": "#67bae4"
				},
				{
					"visibility": "on"
				}
			]
		}
	];

	function initialize(params) {
		if (map) {
			return;
		}
		var coords = params.coords;
		var target = params.target;
		var altText = params.altText;

		var positionOfTarget = new google.maps.LatLng(coords[0], coords[1]);
		console.log(positionOfTarget);

		mapOptions = {
			center: positionOfTarget,
			zoom: 17,
			scrollwheel: false,
			styles: mapStyle
		};

		map = new google.maps.Map(target, mapOptions);

		var marker = new google.maps.Marker({
			position: positionOfTarget,
			title: altText,
			animation: google.maps.Animation.DROP,
			icon: {
				url: "imgs/marker.min.svg",
				scaledSize: new google.maps.Size(Math.round(305 * 0.5), Math.round(380 * 0.5))
			}
		});

		if (params.click) {
			marker.addListener('click', function() {
				window.open(params.click);
			})
		}

		marker.setMap(map);

	}


	$.fn.initGoogleMap = function() {

		var _this = this;

		var coords = _this.attr("data-coords").split(",").map(parseFloat);
		var altText = _this.attr("data-alt");
		var onclick = _this.attr("data-click");

		attachGoogleMapsLib(function() {
			initialize({
				coords: coords,
				target: _this[0],
				altText: altText,
				click: onclick
			})
		});



		return this;

	}

})(jQuery);
